import { Component, Watch } from 'vue-property-decorator';
import Superbutton from 'tivigi/src/components/Superbutton/Superbutton'
import SM3Base from '../SM3Base/SM3Base';

import FloatingWindow from 'tivigi/src/components/FloatingWindow/FloatingWindow'

import WithRender from './Startseite.html';

@WithRender
@Component({
    components: { FloatingWindow,  Superbutton }
})
export default class Startseite extends SM3Base {


    
    
}


